import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Header.css';

const Header = () => {
  const { t, i18n } = useTranslation();
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
    setShowMenu(false);
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <header className="header">
      <div className="header-container">
        <h1 className="logo">
          <Link to="/">{t('app_name')}</Link>
        </h1>
        <div className="header-controls">
          <div className="control-wrapper">
            <select 
              className="language-select"
              value={i18n.language} 
              onChange={(e) => changeLanguage(e.target.value)}
            >
              <option value="en">English</option>
              <option value="ko">한국어</option>
              <option value="ja">日本語</option>
              <option value="es">Español</option>
            </select>
          </div>
          
          <div className="control-wrapper">
            {currentUser ? (
              <div className="user-menu">
                <button className="user-button" onClick={toggleMenu}>
                  <img 
                    src={currentUser.photoURL || '/images/default-avatar.png'} 
                    alt={currentUser.name} 
                    className="user-avatar" 
                  />
                </button>
                {showMenu && (
                  <div className="dropdown-menu">
                    <Link to="/mypage" onClick={() => setShowMenu(false)}>
                      {t('my_page')}
                    </Link>
                    <button onClick={handleLogout}>
                      {t('logout')}
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/login" className="login-button">
                {t('login')}
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
